export default "__VITE_ASSET__DdPoxcsf__"